import { observable, computed, action } from 'mobx'
import links from 'src/client/misc/links'
import { browserHistory } from 'react-router'

export default class WizardCompletedState {
  constructor({ wizard }) {
    this.wizard = wizard
    this.hideBackButton = true
  }

  stepId = 'WizardCompleted'
  workspaceName =
    (window.__workspaceDomain &&
      window.__workspaceDomain.workspace &&
      window.__workspaceDomain.workspace.name) ||
    'Worklayer'

  title = `Thank you for using ${this.workspaceName}!`
  trackingId = 'Onboarding - Payment Success'

  @observable
  showingReferrerModal = false

  @computed
  get member() {
    return this.wizard.rootStore.sessionStore.member
  }

  @computed
  get workspace() {
    return this.wizard.rootStore.sessionStore.workspace
  }

  @computed
  get showPersonalFilingTip() {
    const legend = this.wizard.getStep('ProjectType').legend
    if (!legend) {
      return false
    }

    return legend.id === 'BUSINESS_TAX_RETURN'
  }

  @computed
  get job() {
    return this.wizard.job
  }

  @action.bound
  toggleReferrerModal() {
    this.showingReferrerModal = !this.showingReferrerModal
  }

  @action.bound
  showEmailDialog() {
    this.wizard.rootStore.changeEmailDialogStore.show()
  }

  @action.bound
  exit() {
    browserHistory.replace(links.projectDetails(this.job.id))
  }
}
